exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".world-list .filters {\n  margin-top: 20px;\n}\n.world-list .filters .form-group {\n  margin-bottom: 0;\n}\n.world-list .new-area {\n  padding-top: 3px;\n}\n.world-list .world-filter {\n  display: inline-block;\n  margin-left: 20px;\n}\n.world-list .area-list {\n  min-width: 768px;\n}\n.world-list .status-filter {\n  display: inline-block;\n  margin-left: 15px;\n}\n.world-list .search-filter {\n  display: inline-block;\n  width: 250px;\n}\n.world-list .new-area-link {\n  display: inline-block;\n  line-height: 35px;\n}\n.world-list .area-list area-card:nth-child(3n) {\n  margin-right: 0;\n}\n.world-list area-card {\n  margin-top: 10px;\n  margin-bottom: 10px;\n  margin-right: 20px;\n  display: inline-block;\n  width: 227px !important;\n  height: 298px !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/task/cot-web/src/app/components/areas/list/list.component.less
// module id = ../../../../../src/app/components/areas/list/list.component.less
// module chunks = main